/*
 *  I01EVACONSSYSTECSI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-02 18:09:18 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I01EVACONSSYSTECS_SECTION_0_TITLE: "Détaillez la typologie des logements de votre installation afin d'en obtenir les consommations ECS ",
  I01EVACONSSYSTECS_in_typeCalcul: '', //do not delete,required. auto generated code for empty title for segment
  I01EVACONSSYSTECS_in_typeCalcul_0: 'Stockage ECS',
  I01EVACONSSYSTECS_in_typeCalcul_1: 'Stockage primaire',
  I01EVACONSSYSTECS_in_t1_Ddo: 'T1 (douche)',
  I01EVACONSSYSTECS_in_t1_ba: 'T1 (baignoire)',
  I01EVACONSSYSTECS_in_t2_do: 'T2 (douche)',
  I01EVACONSSYSTECS_in_t2_ba: 'T2 (baignoire)',
  I01EVACONSSYSTECS_in_t3_ev_lav_ba: 'T3 ( un évier, un lavabo et une baignoire)',
  I01EVACONSSYSTECS_in_t3_ba_do: 'T3 (une baignoire et une douche)',
  I01EVACONSSYSTECS_in_t4_ba: 'T4 (une baignoire)',
  I01EVACONSSYSTECS_in_t4_ba_do: 'T4 (une baignoire et une douche)',
  I01EVACONSSYSTECS_in_t56_ba: 'T5 / T6 (une baignoire)',
  I01EVACONSSYSTECS_in_t56_ba_do: 'T5 / T6 (une baignoire et une douche)',
  I01EVACONSSYSTECS_in_T56_2ba: 'T5 / T6 (deux baignoires)',
  I01EVACONSSYSTECS_res_totalLogementStandard: 'Total logement standard',
  I01EVACONSSYSTECS_SECTION_1_TITLE: 'Indicateurs de puisage et besoin',
  I01EVACONSSYSTECS_res_consJour: 'Besoin moyen / jour',
  I01EVACONSSYSTECS_res_maxVolStackagECS: 'Besoin de pointe / jour',
  I01EVACONSSYSTECS_res_consoHPointe: 'Consommation / heure de pointe',
  I01EVACONSSYSTECS_res_conso10mn: 'Consommation / 10 mn',
  I01EVACONSSYSTECS_SECTION_2_TITLE2: 'Calcul échangeur instantané',
  I01EVACONSSYSTECS_in_tempFroid: 'Température eau froide',
  I01EVACONSSYSTECS_in_tempChaude: 'Température eau chaude',
  I01EVACONSSYSTECS_res_puissanceThermique: 'Puissance échangeur instantanée',
  I01EVACONSSYSTECS_res_debit_dtu: 'Débit DTU',
  I01EVACONSSYSTECS_SECTION_3_TITLE: 'Type de couple ECS',
  I01EVACONSSYSTECS_in_VolStockageECS: 'Volume stockage',
  I01EVACONSSYSTECS_res_puissanceSemiECS: 'Puissance échangeur',
  I01EVACONSSYSTECS_in_volumeStockageAccECS: 'Volume Stockage',
  I01EVACONSSYSTECS_SECTION_5_TITLE: "Stokage primaire et puissance de l'appoint",
  I01EVACONSSYSTECS_in_tempRetourEchangeur: 'Température retour échangeur',
  I01EVACONSSYSTECS_in_tempStockagePrimaire: 'Température stockage primaire',
  I01EVACONSSYSTECS_in_volumStockageAppoint: 'Volume stockage ',
  I01EVACONSSYSTECS_res_puissanceAppoint: 'Puissance générateur',
  I01EVACONSSYSTECS_mail_type_stockage: 'Type de stockage'
}
